<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="pt-0 mb-2">Next Crop</b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <template v-for="(projection, index) in projections">
          <soil-crop-form
            :index="index"
            :key="index"
            :options="cropNames"
            :projection="projection"
            :projectionListLength="projections.length"
            @updateProjection="updateProjection"
            @updateProjectionList="updateProjectionList"
          >
          </soil-crop-form>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SoilCropForm from "./SoilCropForm";
import crops from "@/shared/_crops";
export default {
  name: "SoilNextCropFormGroups",
  components: {
    SoilCropForm
  },
  props: ["submission", "index"],
  computed: {
    cropNames() {
      return crops.map(i => i.crop);
    }
  },
  data() {
    return {
      projections: [
        {
          crop: null,
          unit: null,
          yield: null
        }
      ]
    };
  },
  methods: {
    updateProjection({ update, field, index }) {
      this.projections = this.projections.map((projection, projectionIndex) => {
        if (projectionIndex === index) {
          if (field === "crop") {
            const crop = crops.find(item => item.crop === update);
            let irrigated = this.submission.submission_soil.irrigated
            return {
              crop: crop.crop,
              yield: irrigated == 1
                ? crop && crop.irrigated || null
                : crop && crop.dryland || null,
              unit: crop.units
            };
          } else {
            return {
              ...projection,
              [field]: update
            };
          }
        } else {
          return projection;
        }
      });
    },
    updateProjectionList({ index, action }) {
      if (action === "remove") {
        this.projections.splice(index, 1);
      } else {
        this.projections = [
          ...this.projections,
          {
            crop: null,
            yield: null,
            unit: null
          }
        ];
      }
    }
  },
  watch: {
    projections: {
      handler() {
        const cropUpdate = [...this.projections].map(projection => {
          const { crop, unit } = projection;
          return {
            crop,
            yield: projection.yield,
            unit
          };
        });
        this.$emit("onNextCropChange", cropUpdate);
      },
      deep: true
    },
    submission: {
      handler(value) {
        if (value && value.submission_soil) {
          const a = JSON.stringify(value.submission_soil.projections);
          const b = JSON.stringify(this.projections);
          if (a !== b) {
            this.projections = value.submission_soil.projections;
          }
        }
      },
      deep: true,
      immediate: true
    },
    'submission.submission_soil.irrigated': {
      handler() {
        this.projections.forEach(projection => {
          const crop = crops.find(item => item.crop === projection.crop)
          let irrigated = this.submission && this.submission.submission_soil && this.submission.submission_soil.irrigated
          projection.yield = irrigated == 1
            ? crop && crop.irrigated || null
            : crop && crop.dryland || null
        })
      },
      deep: true,
    },
  }
};
</script>
